import { TEMPLATE_PAGE_SIZE } from '../../../constants/templateGrid';
import { clearFilters, updateFiltersRecursively } from '../../../utils/filters';
import { handleDeepUpdateTemplates } from '../../../utils/templateGrid/template.util';
import { useReducer } from 'react';
import { getDefaultTemplateState } from './TemplateState';
const Reducer = (state, action) => {
    switch (action.type) {
        case 'templates-filters-loading':
            state = { ...state, loading: { ...state.loading, filters: true } };
            break;
        case 'templates-filters-loaded':
            state = {
                ...state,
                filters: [...action.filters],
                loading: {
                    ...state.loading,
                    filters: false,
                },
            };
            break;
        case 'templates-loading':
            state = { ...state, loading: { ...state.loading, templates: true } };
            break;
        case 'templates-loaded':
            state = {
                ...state,
                loading: { ...state.loading, templates: false },
                noMoreTemplates: action.templates.length < TEMPLATE_PAGE_SIZE,
                templates: {
                    data: action.append
                        ? [...state.templates.data, ...action.templates]
                        : [...action.templates],
                    offset: action.offset,
                    total: action.total,
                },
            };
            break;
        case 'filter-selected':
            state = {
                ...state,
                filters: updateFiltersRecursively(state.filters, { selected: action.selected }, action.filter),
            };
            break;
        case 'filter-collapsed':
            state = {
                ...state,
                filters: updateFiltersRecursively(state.filters, { collapsed: action.collapsed }, action.filter),
            };
            break;
        case 'filters-updated':
            state = {
                ...state,
                filters: [...action.filters],
            };
            break;
        case 'filters-cleared':
            state = {
                ...state,
                filters: clearFilters(state.filters),
            };
            break;
        case 'search-query-updated':
            state = {
                ...state,
                searchQuery: action.searchQuery,
            };
            break;
        case 'toggle-favourite':
            state = {
                ...state,
                templates: handleDeepUpdateTemplates(state.templates, action.templateId, action.status, state.isFavourite),
            };
            break;
        case 'set-is-favourite':
            state = {
                ...state,
                isFavourite: action.isFavourite,
            };
            break;
        case 'set-selected-favourite-dimension':
            state = {
                ...state,
                selectedDimensionForFavourite: action.dimension,
            };
            break;
        case 'update-loaders':
            state = {
                ...state,
                hideLoaders: action.status,
            };
            break;
        case 'set-is-purchased':
            state = {
                ...state,
                isPurchased: action.isPurchased,
            };
            break;
        case 'set-selected-purchased-dimension':
            state = {
                ...state,
                selectedDimensionForPurchased: action.dimension,
            };
            break;
        default:
            break;
    }
    return state;
};
const useTemplateReducer = () => {
    return useReducer(Reducer, getDefaultTemplateState());
};
export default useTemplateReducer;
